import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MenuItem } from 'src/app/models';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent {
  selectedSite: any = '';
  name = '';

  sites: MenuItem[] = [
    {
      name: 'glam',
      code: 'AU',
      pages: [
        {
          cname: 'Painel',
          code: 'configuracoes/painel'
        },
        {
          cname: 'LP Clube',
          code: 'configuracoes/lp-club'
        },
        // {
        //   cname: 'Vitrine',
        //   code: 'configuracoes/vitrine'
        // },
        {
          cname: 'Edições',
          code: 'configuracoes/editions?businessUnitId=1'
        },
        {
          name: 'Favoritos',
          code: 'AU',
          subPages: [
            {
              cname: 'Temas',
              code: 'configuracoes/wishlist/themes'
            },
            {
              cname: 'Banners',
              code: 'configuracoes/wishlist/banners'
            }
          ]
        },
        {
          cname: 'Home',
          code: 'configuracoes/glam/new-home'
        },
        {
          cname: 'Campanhas',
          code: 'configuracoes/glam/campaigns'
        },
        {
          cname: 'Banner campanha',
          code: 'configuracoes/dms/glamshop/featuredCampaignBanner'
        },
        {
          cname: 'Collections de lojinhas',
          code: 'configuracoes/collections-lojinhas'
        },
        {
          cname: 'Formulário pós-checkout',
          code: 'configuracoes/form-after-checkout'
        }
      ]
    },
    {
      name: 'Mensmarket',
      code: 'AU',
      pages: [
        {
          cname: 'Clube',
          code: 'configuracoes/mensmarket-clube/mensmarket_clube'
        },
        {
          cname: 'Prime',
          code: 'configuracoes/mensmarket-prime/mensmarket_prime'
        },
        {
          cname: 'Select',
          code: 'configuracoes/mensmarket-select/mensmarket_select'
        },
        {
          cname: 'Promocoes',
          code: 'configuracoes/mensmarket-promocoes/mensmarket_promocoes'
        },
        {
          cname: 'Edições',
          code: 'configuracoes/editions?businessUnitId=2'
        },
        {
          cname: 'Home',
          code: 'configuracoes/mens/home'
        },
        {
          cname: 'Banner campanha',
          code: 'configuracoes/dms/mens_market/featuredCampaignBanner'
        }
      ]
    },
    {
      name: 'LPs Promocionais',
      code: 'AU',
      pages: [
        {
          cname: 'LP Assinaturas',
          code: 'configuracoes/lp-signatures/lp_signatures'
        },
        {
          cname: 'LP convite',
          code: 'configuracoes/lp-glamgirl/lp_glamgirl'
        },
        {
          cname: 'LP partners',
          code: 'configuracoes/lp-partners/lp_partners'
        },
        {
          cname: 'LP royal',
          code: 'configuracoes/lp-royals/lp_royals'
        },
        {
          cname: 'LP Edição',
          code: 'configuracoes/lp-edition/lp_edition'
        },
        {
          name: 'LPs Growth',
          code: 'AU',
          subPages: [
            {
              cname: 'LP Growth 1',
              code: 'configuracoes/lp-growth-1/lp_growth_1'
            },
            {
              cname: 'LP Growth 2',
              code: 'configuracoes/lp-growth-2/lp_growth_2'
            },
            {
              cname: 'LP Growth 3',
              code: 'configuracoes/lp-growth-3/lp_growth_3'
            },
            {
              cname: 'LP Growth 4',
              code: 'configuracoes/lp-growth-4/lp_growth_4'
            },
            {
              cname: 'LP Growth 5',
              code: 'configuracoes/lp-growth-5/lp_growth_5'
            },
            {
              cname: 'LP Growth 6',
              code: 'configuracoes/lp-growth-6/lp_growth_6'
            },
            {
              cname: 'LP Growth 7',
              code: 'configuracoes/lp-growth-7/lp_growth_7'
            },
            {
              cname: 'LP Growth 8',
              code: 'configuracoes/lp-growth-8/lp_growth_8'
            },
            {
              cname: 'LP Growth 9',
              code: 'configuracoes/lp-growth-9/lp_growth_9'
            },
            {
              cname: 'LP Growth 10',
              code: 'configuracoes/lp-growth-10/lp_growth_10'
            }
          ]
        }
      ]
    },
    {
      name: 'Marcas Próprias',
      code: 'AU',
      pages: [
        {
          cname: 'Glam Beauty',
          code: 'configuracoes/glam-beauty'
        },
        {
          cname: 'Malmo',
          code: 'configuracoes/malmo'
        },
        {
          cname: 'Mens',
          code: 'configuracoes/mens'
        }
      ]
    }
  ];

  constructor(
    private router: Router,
    private title: Title
  ) {
    this.title.setTitle('Customização do site');
  }

  onChange(event: any) {
    if (!event.code) return;
    this.router.navigateByUrl('/' + event.code);
  }
}
